
import jwt_decode from "jwt-decode";

//const API_BASE_URL = "https://localhost:44375/";
//const API_BASE_URL = "https://hmcareplanner202220230305205458.azurewebsites.net/";
//const API_AUTH_TOKEN = "auth_token";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_NOTIFICATION_HUB_URL = process.env.REACT_APP_API_NOTIFICATION_HUB_URL;
const API_AUTH_TOKEN = process.env.REACT_APP_API_AUTH_TOKEN;


//const token = localStorage.getItem(API_AUTH_TOKEN);

let CURRENT_USER_NAME = "";
let CURRENT_USER_EMAIL = "";
let CURRENT_USER_ID = "";
let CURRENT_USER_ROLE = "";
let CURRENT_USER_TENANT_ID = "";
let CURRENT_USER_TENANT_NAME = "";
let CURRENT_USER_TENANT_DISPLAY_NAME = "";
let CURRENT_USER_TENANT_EMAIL = "";
let CURRENT_USER_TENANT_ADDRESS = "";
let CURRENT_USER_TENANT_EXP = "";
let CURRENT_USER_PROFILEIMAGE = "";


    const token = localStorage.getItem(API_AUTH_TOKEN);

    if(token!="" && token != null)     {
        const decoded = jwt_decode(token);
        
        CURRENT_USER_NAME = decoded.UserName;
        CURRENT_USER_EMAIL = decoded.UserEmail;
        CURRENT_USER_ID = decoded.UserId;
        CURRENT_USER_ROLE = (decoded.UserRole=="1"?"admin":"user");
        CURRENT_USER_TENANT_ID = decoded.TenantID;
        CURRENT_USER_TENANT_NAME = decoded.TenantName;
        CURRENT_USER_TENANT_DISPLAY_NAME = decoded.TenantDisplayName;
        CURRENT_USER_TENANT_EMAIL = decoded.TenantEmail;
        CURRENT_USER_TENANT_ADDRESS = decoded.TenantAddress;
        CURRENT_USER_TENANT_EXP = decoded.exp;
        CURRENT_USER_PROFILEIMAGE = decoded.ProfileImage??"/images/avatar/c.jpg";        
        }


export default {
    API_BASE_URL, 
    API_NOTIFICATION_HUB_URL,
    API_AUTH_TOKEN,
    CURRENT_USER_NAME,
    CURRENT_USER_ID,
    CURRENT_USER_ROLE,
    CURRENT_USER_TENANT_ID,
    CURRENT_USER_TENANT_NAME,
    CURRENT_USER_TENANT_DISPLAY_NAME,
    CURRENT_USER_TENANT_EMAIL,
    CURRENT_USER_TENANT_ADDRESS,
    CURRENT_USER_TENANT_EXP,
    CURRENT_USER_PROFILEIMAGE,
}